<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['日化品牌', title + '日化品牌信息']" />
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="12">
            <el-form ref="form" class="add-form" :rules="rules" :model="form" label-width="280px">
              <el-form-item label="驳回原因：" v-if="form.status === '3'">
                <p class="reject-text">{{ form.reason }}</p>
              </el-form-item>
              <el-form-item label="品牌名：" prop="name">
                <el-input :disabled="title === '编辑'" v-model.trim="form.name" placeholder="不超过50个字"></el-input>
                <p style="line-height: 30px">提示：品牌名提交后无法修改，若填写有误只能重新创建品牌信息，请准确填写</p>
              </el-form-item>
              <el-form-item label="logo：" prop="logo">
                <logoUpload @success="getLogo" :img="logoList" :min="1" />
              </el-form-item>
              <el-form-item label="英文名：" prop="englishName">
                <el-input v-model.trim="form.englishName" maxlength="30" show-word-limit ></el-input>
              </el-form-item>
              <el-form-item label="宣传图：" prop="picture">
                <uploadXc @success="getPicture" :img="pictureList" :limit="20" :size="2" />
              </el-form-item>
              <el-form-item label="视频：" prop="videoUrl">
                <videoUpload @success="getVideo" :list="videoList" />
              </el-form-item>
              <el-form-item label="一级品类：" prop="oneList">
                <el-checkbox-group v-model="form.oneList" @change="oneChange" :max="3">
                  <template v-for="(item, index) in brandCategoryList">
                    <el-checkbox :label="item.id" :key="index">{{
                        item.name
                    }}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="二级品类：" prop="two">
                <div v-for="(item, index) in twoList" :key="index">
                  <span style="color: blue">{{ item.name }}：</span>{{ item.data.join(",") }}
                </div>
              </el-form-item>
              <el-form-item label="主推：" prop="mainPush">
                <el-radio-group v-model="form.mainPush">
                  <el-radio :label="item.id" v-for="(item, index) in twoList" :key="index">{{ item.name }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="原产地：" prop="originList">
                <el-cascader style="width: 100%" v-model="form.originList" clearable :options="originOptions"
                  :props="defaultProps"></el-cascader>
              </el-form-item>
              <el-form-item label="归属：" prop="owner">
                <el-radio-group v-model="form.owner" @change="changeOwner">
                  <el-radio label="自有品牌"></el-radio>
                  <el-radio label="代理品牌"></el-radio>
                </el-radio-group>
                <p class="notes-text" v-if="form.owner === '自有品牌'">请上传该品牌的商标注册证明（需证明该商标所属贵司并在有效期内的完整链路文件）</p>
                <p class="notes-text" v-if="form.owner === '代理品牌'">文件包含：商标注册证明-商标持有方授权代理文件（需完整链路）</p>
              </el-form-item>
              <el-form-item v-if="form.owner === '代理品牌'" label="品牌商标隶属公司：" prop="agencyCompany">
                <el-input v-model.trim="form.agencyCompany"></el-input>
              </el-form-item>
              <el-form-item :label="form.owner === '代理品牌' ? '品牌代理相关证明：' : '商标注册相关证明：'" prop="certificateUrl">
                <certificateUpload @success="getCertificateUrl" :img="certificateUrlList" :limit="20" />
              </el-form-item>
              <el-form-item :label="form.owner === '代理品牌' ? '品牌代理有效期' : '商标持有有效期'" prop="lifespan">
                <el-date-picker style="width: 100%" v-model="form.lifespan" type="date" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="选择时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="是否上传补充资料：" prop="otherFlag">
                <el-radio-group v-model="form.otherFlag" @change="changeOtherFlag">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="2">否</el-radio>
                </el-radio-group>
                <p class="notes-text" v-if="form.otherFlag === '1'">包含但不限于明星、文件变更等授权或关联文件</p>
              </el-form-item>
              <el-form-item label="补充材料" prop="otherMaterials" v-if="form.otherFlag === '1'">
                <certificateUpload @success="getOtherMaterials" :img="otherMaterialsList" :limit="20" />
              </el-form-item>
              <el-form-item label="补充材料有效期：" prop="otherLifespan" v-if="form.otherFlag === '1'">
                <el-date-picker style="width: 100%" v-model="form.otherLifespan" type="date" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="选择时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="贸易属性：">
                <el-radio-group v-model="form.tradeProperty">
                  <el-radio label="一般贸易"></el-radio>
                  <el-radio label="跨境贸易"></el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否做外贸：" prop="foreignTrade">
                <el-radio-group v-model="form.foreignTrade">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="外贸占比：" prop="foreignTradeProportion" v-if="form.foreignTrade === '1'">
                <el-input v-model="form.foreignTradeProportion"></el-input>
              </el-form-item>
              <el-form-item label="简介：" prop="intro">
                <el-input v-model.trim="form.intro" type="textarea" :rows="4" placeholder="不超过1000个字"></el-input>
              </el-form-item>
              <el-form-item class="label-text" label="请勾选该品牌招商的代理渠道：" prop="proxyChannel">
<!--                <div class="label-item">勾选渠道前，请点击箭头展开渠道节点查看区域范围，默认为全国</div>-->
                <div class="tree-box">
                  <el-tree ref="proxyTree" :data="proxyData" :default-checked-keys="proxyKeys" show-checkbox
                    node-key="id" @check="handleProxyChannel" :props="defaultProps">
                  </el-tree>
                </div>
              </el-form-item>
              <el-form-item class="label-text" label="请勾选该品牌招商的门店渠道：" prop="storeChannel">
<!--                <div class="label-item">勾选渠道前，请点击箭头展开渠道节点查看区域范围，默认为全国</div>-->
                <div class="tree-box">
                  <el-tree ref="storeTree" :data="proxyData" :default-checked-keys="storeKeys" show-checkbox
                    node-key="id" @check="handleStoreChannel" :props="defaultProps">
                  </el-tree>
                </div>
              </el-form-item>
              <el-form-item label="创立时间：">
                <el-date-picker style="width: 100%" v-model="form.foundDate" type="year" format="yyyy"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="品牌定位：" prop="position">
                <el-input v-model.trim="form.position" placeholder="可介绍贵司品牌定位、优势、卖点等，不超过50个字"></el-input>
              </el-form-item>
              <!--            <el-form-item label="品牌实力：">-->
              <!--              <el-input-->
              <!--                  v-model="form.bindPower"-->
              <!--                  placeholder="不超过100个字"-->
              <!--              ></el-input>-->
              <!--            </el-form-item>-->
              <!-- <el-form-item label="备注：" prop="remark">
                  <el-input
                    v-model="form.remark"
                    type="textarea"
                    :rows="4"
                    placeholder="不超过100个字"
                  ></el-input>
                </el-form-item> -->
              <el-form-item label="功能标签：" prop="label">
                <el-checkbox-group v-model="form.label">
                  <el-checkbox label="一件代发"></el-checkbox>
                  <el-checkbox label="可以寄样"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="排序：">
                <el-input-number style="width: 100%" :min="0" v-model="form.sort"></el-input-number>
              </el-form-item>
              <el-form-item label="创立人：" prop="founder">
                <el-input v-model.trim="form.founder"></el-input>
              </el-form-item>
            </el-form>
            <div class="info-footer">
              <el-button type="primary" @click="save">提交审核</el-button>
              <el-button @click="back">取消</el-button>
            </div>
          </el-col>
        </el-row>
        <!-- <div class="phone-btn">
          <el-button @click="isShow=true">预览</el-button>
        </div>
        <transition name="phoneBox">
          <div v-if="isShow" class="phone-box" @click="isShow=false">
            <div class="close" @click="isShow=false">X</div>
            <iphoneX v-model="isShow" />
          </div>
        </transition> -->
      </el-card>
    </div>
  </div>
</template>
<script>
import navHeader from '../../components/navHeader.vue'
import uploadXc from '../../components/xcUpload.vue'
import logoUpload from '../../components/logoUpload.vue'
import certificateUpload from '../../components/certificateUpload.vue'
import iphoneX from '../../components/iphonex.vue'
import videoUpload from '../../components/videoUpload'

export default {
  data () {
    return {
      value: '',
      id: '',
      type: 'add',
      loading: true,
      isShow: false,
      title: '添加',
      form: {
        name: '',
        originList: [],
        oneList: [],
        label: [],
        certificateUrl: '',
        lifespan: '',
        otherFlag: '',
        otherMaterials: '',
        otherLifespan: '',
        proxyChannel: '',
        storeChannel: '',
        picture: '',
        logo: '',
        videoUrl: '',
        foreignTrade: '',
        foreignTradeProportion: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入中文名', trigger: 'blur' },
          { max: 50, message: '长度在50 个字符内', trigger: 'blur' }
        ],
        logo: {
          required: true,
          message: '请上传logo图片，大小不能超过 5MB!',
          trigger: 'change'
        },
        englishName: [
          {
            required: true, message: '请输入英文名'
          },
          {
            validator: function (rule, value, callback) {
              if (!(/[\u4E00-\u9FA5]/g.test(value))) {
                callback()
              } else {
                callback(new Error('请输入英文'))
              }
            },
            trigger: 'blur'
          }
        ],
        picture: {
          required: true,
          message: '请上传宣传图片，大小不能超过 5MB!',
          trigger: 'change'
        },
        oneList: {
          required: true,
          message: '请选择一级品类',
          trigger: 'blur'
        },
        mainPush: {
          required: true,
          message: '请选择主推品类',
          trigger: 'blur'
        },
        owner: {
          required: true,
          message: '请选择归属',
          trigger: 'change'
        },
        certificateUrl: {
          required: true,
          message: '请上传相关证明',
          trigger: 'change'
        },
        lifespan: {
          required: true,
          message: '请输入有效期',
          trigger: 'blur'
        },
        otherMaterials: {
          required: true,
          message: '请输入补充材料',
          trigger: 'blur'
        },
        otherLifespan: {
          required: true,
          message: '请选择补充材料有效期',
          trigger: 'blur'
        },
        intro: [
          { required: true, message: '请输入简介', trigger: 'blur' },
          { max: 1000, message: '长度在1000个字符内', trigger: 'blur' }
        ],
        originList: {
          required: true,
          message: '请选择原产地',
          trigger: 'blur'
        },
        position: {
          max: 50,
          message: '长度在50 个字符内',
          trigger: 'blur'
        },
        remark: {
          max: 100,
          message: '长度在100 个字符内',
          trigger: 'blur'
        },
        agencyCompany: {
          max: 50,
          message: '长度在50 个字符内',
          trigger: 'blur'
        },
        founder: {
          max: 50,
          message: '长度在50 个字符内',
          trigger: 'blur'
        },
        proxyChannel: {
          required: true,
          message: '请勾选该品牌招商的代理渠道',
          trigger: 'blur'
        },
        storeChannel: {
          required: true,
          message: '请勾选该品牌招商的门店渠道',
          trigger: 'blur'
        }
        // foreignTrade: {
        //   required: true,
        //   message: '请选择是否做外贸',
        //   trigger: 'change'
        // },
        // foreignTradeProportion: {
        //   required: true,
        //   message: '请输入外贸占比',
        //   trigger: 'change'
        // }
      },
      originOptions: [],
      brandCategoryList: [],
      twoList: [],
      proxyData: [],
      proxyKeys: [],
      storeKeys: [],
      logoList: [],
      pictureList: [],
      videoList: [],
      certificateUrlList: [],
      otherMaterialsList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
        value: 'id'
      }
    }
  },
  components: {
    navHeader,
    logoUpload,
    certificateUpload,
    uploadXc,
    iphoneX,
    videoUpload
  },
  created () {
    this.getChannelList()
    this.getBrandCategoryList()
    this.getProducingAreaList()
    if (this.$route.params.id) {
      this.id = this.$route.params.id
    } else {
      this.id = ''
    }
    if (this.$route.params.type) {
      this.type = this.$route.params.type
      this.title = '编辑'
    } else {
      this.type = 'add'
      this.loading = false
      this.title = '添加'
    }
  },
  methods: {
    getDetail (id) {
      this.$http
        .post('/cosmeticBrand/cosmeticBrand/detail', { id })
        .then((res) => {
          if (res.data.code === '200') {
            let data = res.data.data
            this.form = res.data.data
            let list = this.form.videoUrl ? this.form.videoUrl.split(',') : []
            list.forEach(item => {
              this.videoList.push({ name: item, url: item })
            })
            this.logoList = this.form.logo ? this.form.logo.split(',') : []
            this.pictureList = this.form.picture ? this.form.picture.split(',') : []
            this.form.oneList = data.one ? data.one.split(',') : []
            this.form.oneList.forEach((item) => parseInt(item))
            this.form.originList = data.origin ? data.origin.split(',') : []
            this.form.label = data.label ? data.label.split(',') : []
            this.form.originList.forEach((item) => parseInt(item))
            this.brandCategoryList.forEach((item) => {
              this.form.oneList.forEach((i) => {
                if (i === item.id) {
                  this.twoList.push({
                    name: item.name,
                    id: item.id,
                    data: item.children.map((n) => n.name)
                  })
                }
              })
            })
            this.proxyKeys = this.form.proxyChannel ? this.form.proxyChannel.split(',') : []
            this.storeKeys = this.form.storeChannel ? this.form.storeChannel.split(',') : []
            this.certificateUrlList = this.form.certificateUrl ? this.form.certificateUrl.split(',') : []
            this.otherMaterialsList = this.form.otherMaterials ? this.form.otherMaterials.split(',') : []
          }
          this.loading = false
        })
        .catch((e) => {
          console.log(e)
          this.loading = false
          this.$message.error(e)
        })
    },
    getChannelList () {
      this.$http
        .get('/cosmeticBrand/cosmeticBrand/getChannelList')
        .then((res) => {
          if (res.data.code === '200') {
            this.proxyData = res.data.data
            console.log(this.proxyData)
          }
        })
    },
    getBrandCategoryList () {
      this.$http
        .get('/cosmeticBrand/cosmeticBrand/getBrandCategoryList')
        .then((res) => {
          if (res.data.code === '200') {
            this.brandCategoryList = res.data.data
            if (this.id) {
              this.getDetail(this.id)
            }
          }
        })
    },
    getProducingAreaList () {
      this.$http
        .get('/cosmeticProduct/cosmeticProduct/getProducingAreaList')
        .then((res) => {
          console.log(res)
          if (res.data.code === '200') {
            this.originOptions = res.data.data
          }
        })
    },
    oneChange () {
      this.twoList = []
      this.brandCategoryList.forEach((item) => {
        this.form.oneList.forEach((i) => {
          if (i === item.id) {
            this.twoList.push({
              name: item.name,
              id: item.id,
              data: item.children.map((n) => n.name)
            })
          }
        })
      })
    },
    handleProxyChannel () {
      let keys = this.$refs.proxyTree.getCheckedKeys()
      this.form.proxyChannel = keys.join(',')
    },
    handleStoreChannel () {
      // let node = this.$refs.storeTree.getCheckedNodes();
      let keys = this.$refs.storeTree.getCheckedKeys()
      this.form.storeChannel = keys.join(',')
    },
    getLogo (list) {
      this.form.logo = list.join(',')
    },
    getPicture (list) {
      this.form.picture = list.join(',')
    },
    getVideo (list) {
      this.form.videoUrl = list.map(item => item.url).join(',')
    },
    getCertificateUrl (list) {
      this.form.certificateUrl = list.join(',')
    },
    getOtherMaterials (list) {
      this.form.otherMaterials = list.join(',')
    },
    changeOwner () {
      this.form.certificateUrl = ''
      this.form.lifespan = ''
      this.certificateUrlList = []
    },
    changeOtherFlag () {
      this.form.otherMaterials = ''
      this.form.otherLifespan = ''
      this.otherMaterialsList = []
    },
    back () {
      this.$router.push('/rhBrand')
    },
    save () {
      this.$refs.form.validate((val) => {
        if (val) {
          let params = JSON.parse(JSON.stringify(this.form))
          params.one = this.form.oneList.join(',')
          params.origin = this.form.originList.join(',')
          params.label = this.form.label.join(',')
          delete params.oneList
          delete params.originList
          let url = ''
          if (this.type === 'add') {
            url = '/cosmeticBrand/cosmeticBrand/add'
          } else {
            url = '/cosmeticBrand/cosmeticBrand/update'
          }
          this.$http
            .post(url, params)
            .then((res) => {
              if (res.data.code === '200') {
                this.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定',
                  showClose: false
                }).then(() => { this.$router.back() })
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((e) => {
              console.log(e)
            })
        } else {
          if (!this.form.name) return this.$message.error('请输入中文名')
          if (!this.form.logo) return this.$message.error('请上传logo图片')
          if (!this.form.englishName) return this.$message.error('请输入英文名')
          if (!this.form.picture) return this.$message.error('请上传宣传图片')
          if (this.form.oneList.length === 0) return this.$message.error('请选择一级品类')
          if (!this.form.mainPush) return this.$message.error('请输入主推品类')
          if (this.form.originList.length === 0) return this.$message.error('请选择原产地')
          if (!this.form.owner) return this.$message.error('请选择归属')
          if (!this.form.intro) return this.$message.error('请输入简介')
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.detail-box {
  position: relative;
  height: 100%;

  .phone-btn {
    position: fixed;
    top: 360px;
    right: 140px;
  }

  .detail-content {
    position: relative;
  }

  .box-card ul {
    display: flex;

    li:first-child {
      width: 60%;
      height: 100%;

      .el-row {
        width: 100%;
      }
    }
  }

  .form-box,
  .phone-box {
    display: inline-block;
  }

  .form-box {
    // width: calc(100% - 700px);
    // margin-left: 100px;
  }

  .phone-box {
    position: absolute;
    top: 0;
    right: 30px;
    height: calc(100% - 60px);
    padding: 40px 20px 0;
    background-color: rgba(89, 89, 89, 0.2);

    .close {
      position: absolute;
      top: 60px;
      right: 20px;
      cursor: pointer;
    }
  }
}

.phoneBox-enter,
.phoneBox-leave-to {
  right: -100px;
  opacity: 0;
  transition: all 0.5s linear;
}

.phoneBox-leave,
.phoneBox-enter-to {
  right: -100px;
  opacity: 1;
  transition: all 0.5s linear;
}
</style>



// WEBPACK FOOTER //
// src/pages/rhBrand/detail.vue